(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["searoomlynn_featured_collection"] && !Shopify.designMode) return;
  try {
    
function initFeaturedSwiper() {
  if (typeof Swiper !== 'function') {
    return false;
  }
  var container = document.querySelector('#section-featured .swiper-container');
  if (!container || !container.querySelector('.swiper-slide')) {
    return true;
  }
  if (container.swiper) {
    return true;
  }
  new Swiper(container, {
    navigation: {
      nextEl: '#section-featured .swiper-button-next',
      prevEl: '#section-featured .swiper-button-prev'
    },
    speed: 500,
    allowTouchMove: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    freeMode: true,
    freeModeSticky: false,
    spaceBetween: 0,
    loop: false,
    observer: true,
    observeParents: true,
    pagination: {
      el: '#section-featured .swiper-pagination',
      clickable: true
    }
  });
  return true;
}

if (!initFeaturedSwiper()) {
  var featuredSwiperTries = 0;
  var featuredSwiperTimer = setInterval(function() {
    featuredSwiperTries += 1;
    if (initFeaturedSwiper() || featuredSwiperTries > 40) {
      clearInterval(featuredSwiperTimer);
    }
  }, 50);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_findby_category"] && !Shopify.designMode) return;
  try {
    
  var ranking = new Swiper('#section-category .swiper-container', {
  navigation: {
    nextEl: '#section-category .swiper-button-next',
    prevEl: '#section-category .swiper-button-prev'
  },
  speed: 500,
  allowTouchMove: true,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  freeMode: true,
  freeModeSticky: false,
  spaceBetween: 15,
  loop: false,
  pagination: {
    el: '#section-category .swiper-pagination',
  },
  breakpoints: {
    1024: {
      freeMode: false,
      slidesPerView: 5,
      slidesPerGroup: 5,
      allowTouchMove: false,
      preventClicks: false,
      preventClicksPropagation: false,
      spaceBetween: 20,
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_newarrival"] && !Shopify.designMode) return;
  try {
    
  var newarrival = new Swiper('#section-newarrival .swiper-container', {
  navigation: {
    nextEl: '#section-newarrival .swiper-button-next',
    prevEl: '#section-newarrival .swiper-button-prev'
  },
  speed: 500,
  allowTouchMove: true,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  freeMode: true,
  freeModeSticky: false,
  spaceBetween: 15,
  loop: false,
  observer: true,
  observeParents: true,
  pagination: {
    el: '#section-newarrival .swiper-pagination',
    type: 'progressbar',
  },
  breakpoints: {
    1024: {
      freeMode: false,
      slidesPerView: 3,
      slidesPerGroup: 3,
      allowTouchMove: false,
      preventClicks: false,
      preventClicksPropagation: false,
      spaceBetween: 24,
    }
  },
  on: {
    imagesReady: function () {
      this.update();
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_news"] && !Shopify.designMode) return;
  try {
    
  var news = new Swiper('#section-news .swiper-container', {
  navigation: {
    nextEl: '#section-news .swiper-button-next',
    prevEl: '#section-news .swiper-button-prev'
  },
  speed: 500,
  allowTouchMove: true,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  freeMode: true,
  freeModeSticky: false,
  spaceBetween: 15,
  loop: false,
  pagination: {
    el: '#section-news .swiper-pagination',
  },
  breakpoints: {
    1024: {
      freeMode: false,
      slidesPerView: 1,
      slidesPerGroup: 1,
      allowTouchMove: false,
      spaceBetween: 24,
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_pickup_item"] && !Shopify.designMode) return;
  try {
    
  var pickupitem = new Swiper('#section-pickupitem .swiper-container', {
  navigation: {
    nextEl: '#section-pickupitem .swiper-button-next',
    prevEl: '#section-pickupitem .swiper-button-prev'
  },
  speed: 500,
  allowTouchMove: true,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  freeMode: true,
  freeModeSticky: false,
  spaceBetween: 15,
  loop: false,
  observer: true,
  observeParents: true,
  pagination: {
    el: '#section-pickupitem .swiper-pagination',
    type: 'progressbar',
  },
  breakpoints: {
    1024: {
      freeMode: false,
      slidesPerView: 3,
      slidesPerGroup: 3,
      allowTouchMove: false,
      preventClicks: false,
      preventClicksPropagation: false,
      spaceBetween: 24,
    }
  },
  on: {
    imagesReady: function () {
      this.update();
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_ranking"] && !Shopify.designMode) return;
  try {
    
  var ranking = new Swiper('#section-ranking .swiper-container', {
  navigation: {
    nextEl: '#section-ranking .swiper-button-next',
    prevEl: '#section-ranking .swiper-button-prev'
  },
  speed: 500,
  allowTouchMove: true,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  freeMode: true,
  freeModeSticky: false,
  spaceBetween: 15,
  loop: false,
  pagination: {
    el: '#section-ranking .swiper-pagination',
    type: 'progressbar',
  },
  breakpoints: {
    1024: {
      freeMode: false,
      slidesPerView: 5,
      slidesPerGroup: 5,
      allowTouchMove: false,
      preventClicks: false,
      preventClicksPropagation: false,
      spaceBetween: 20,
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_recommend_item"] && !Shopify.designMode) return;
  try {
    
  var recommend = new Swiper('#section-recommend_item .swiper-container', {
  navigation: {
    nextEl: '#section-recommend_item .swiper-button-next',
    prevEl: '#section-recommend_item .swiper-button-prev'
  },
  speed: 500,
  allowTouchMove: true,
  slidesPerView: 1,
  slidesPerGroup: 1,
  freeMode: true,
  freeModeSticky: false,
  spaceBetween: 0,
  loop: false,
  pagination: {
    el: '#section-recommend_item .swiper-pagination',
    type: 'progressbar',
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_shoplist_page"] && !Shopify.designMode) return;
  try {
    
  var shoplist = new Swiper('#shoplist_page .swiper-container', {
  speed: 1500,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  allowTouchMove: true,
  slidesPerView: 1.2,
  slidesPerGroup: 1,
  freeMode: true,
  freeModeSticky: false,
  spaceBetween: 10,
  loop: true,
  breakpoints: {
    1024: {
      freeMode: false,
      slidesPerView: 1
    }
  },
  pagination: {
    el: '#shoplist_page .swiper-pagination',
    type: 'progressbar'
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["searoomlynn_the_look"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sectionThelook = document.getElementById('section-thelook');
  if (!sectionThelook) return;

  var pcMinWidth = parseInt(sectionThelook.dataset.pcMinWidth, 10) || 1281;
  var pcQuery = window.matchMedia('(min-width: ' + pcMinWidth + 'px)');
  var lookSwiper = null;

  function demoteLookCloneImages() {
    sectionThelook.querySelectorAll('.swiper-slide-duplicate img').forEach(function (img) {
      if (img.closest('.swiper-slide-active')) return;
      img.setAttribute('loading', 'lazy');
      img.setAttribute('fetchpriority', 'auto');
    });
  }

  function syncTheLookProductList(swiper) {
    var boxes = sectionThelook.querySelectorAll('.the-look-inner.pc .thelook__box');
    if (!boxes.length) return;
    var activeIndex = swiper.realIndex;
    boxes.forEach(function (box, index) {
      box.style.display = index === activeIndex ? 'block' : 'none';
    });
  }

  function lookSwiperOptions(isPc) {
    var options = {
      speed: 500,
      slidesPerGroup: 1,
      spaceBetween: 0,
      threshold: 20,
      preventClicks: true,
      preventClicksPropagation: true,
      navigation: {
        nextEl: sectionThelook.querySelector('.swiper-button-next'),
        prevEl: sectionThelook.querySelector('.swiper-button-prev')
      },
      on: {
        init: function () {
          demoteLookCloneImages();
          syncTheLookProductList(this);
        },
        slideChange: function () {
          syncTheLookProductList(this);
        }
      }
    };

    if (isPc) {
      options.slidesPerView = 4.5;
      options.loop = true;
      options.centeredSlides = true;
    } else {
      options.slidesPerView = 1;
      options.loop = false;
      options.centeredSlides = false;
      options.pagination = {
        el: sectionThelook.querySelector('.swiper-pagination'),
        type: 'fraction',
        formatFractionCurrent: function (number) {
          return number < 10 ? '0' + number : String(number);
        },
        formatFractionTotal: function (number) {
          return number < 10 ? '0' + number : String(number);
        }
      };
    }

    return options;
  }

  function initTheLookSwiper() {
    var container = sectionThelook.querySelector('.swiper-container');
    if (!container || typeof Swiper === 'undefined') return;
    if (lookSwiper) {
      lookSwiper.destroy(true, true);
      lookSwiper = null;
    }
    lookSwiper = new Swiper(container, lookSwiperOptions(pcQuery.matches));
  }

  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    window.addEventListener('load', function () {
      if (typeof Swiper !== 'undefined') callback();
    });
  }

  whenSwiperReady(function () {
    initTheLookSwiper();
    if (typeof pcQuery.addEventListener === 'function') {
      pcQuery.addEventListener('change', initTheLookSwiper);
    } else if (typeof pcQuery.addListener === 'function') {
      pcQuery.addListener(initTheLookSwiper);
    }
  });

  if (sectionThelook.dataset.linkUrl) {
    var linkUrl = sectionThelook.dataset.linkUrl;
    var navSelector = '.swiper-button-prev, .swiper-button-next, .section-thelook__inner a';

    sectionThelook.querySelectorAll('.swiper-button-prev, .swiper-button-next').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    });

    sectionThelook.addEventListener('click', function (event) {
      if (event.target.closest(navSelector)) {
        return;
      }
      window.location.href = linkUrl;
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
